// extracted by mini-css-extract-plugin
export var button = "blogCards-module--button--42eec";
export var cafeFormIntro = "blogCards-module--cafe-form-intro--5a922";
export var card = "blogCards-module--card--2d2bd";
export var cardContainer = "blogCards-module--card-container--d3d05";
export var cardImage = "blogCards-module--card-image--d8c15";
export var cardInfo = "blogCards-module--card-info--70747";
export var cardTitle = "blogCards-module--card-title--81d91";
export var cardWrapper = "blogCards-module--card-wrapper--bce58";
export var highlight = "blogCards-module--highlight--79e6e";
export var redButton = "blogCards-module--red-button--5ab50";
export var redTransparentButton = "blogCards-module--red-transparent-button--05fa7";
export var title = "blogCards-module--title--3c48d";
export var transparentButton = "blogCards-module--transparent-button--74e46";
export var type = "blogCards-module--type--e47a3";
export var wrapper = "blogCards-module--wrapper--aef26";